import { useEmailContext } from '../../../../../../contexts/EmailContext';
import { Box } from '@coolblue-development/freddy';

const TemplatePreview = (): JSX.Element | null => {
  const { templateHtml } = useEmailContext();

  if (!templateHtml) return null;
  return <Box sx={{ '& ul, & ol': { paddingLeft: '1.5em' } }} dangerouslySetInnerHTML={{ __html: templateHtml }} />;
};

export default TemplatePreview;
